<template>
  <div>
    <v-container>
      <v-tabs v-model="profileTabs">
        <v-tab>Profile</v-tab>
        <template v-if="isClient">
          <v-tab>Available Time</v-tab>
          <v-tab>Table</v-tab>
          <v-tab>Application</v-tab>
          <v-tab>VIP Record</v-tab>
        </template>
        <!-- <template v-if="isClient || isMaster">
          <v-tab>Booking</v-tab>
          <v-tab>Reviews</v-tab>
          <v-tab v-if="!isMaster">Product Order</v-tab>
          <v-tab v-if="isMaster">Payroll Note</v-tab>
        </template>
        <v-tab v-if="!isClient">Product and Package Commission</v-tab>
        <v-tab v-if="isMaster">Seniority History</v-tab> -->
      </v-tabs>
      <v-tabs-items v-model="profileTabs" touchless>
        <v-tab-item>
          <v-row>
            <v-col cols="12" :md="false ? 6 : 12">
              <div class="custom-scroll-section">
                <IdentityDetailsCard :model="model" :userId="userId" @reload="reload" />
              </div>
            </v-col>
            <v-col cols="12" md="6" v-if="false">
              <div class="custom-scroll-section">
                <v-tabs v-model="packageTabs">
                  <v-tab>Package owned</v-tab>
                  <v-tab>Package received</v-tab>
                </v-tabs>
                <v-tabs-items v-model="packageTabs" touchless>
                  <v-tab-item>
                    <TicketList :id="id">
                      <template #bottom>
                        <v-btn color="primary" @click="editProductOrderDialog = true">
                          <v-icon>mdi-plus</v-icon>Walkin Product Order
                        </v-btn>
                        <ProductOrderEditDialog
                          v-model="editProductOrderDialog"
                          :defaultProfile="id"
                          :productCategories="productCategories"
                          @create="reload"
                          @update="reload"
                          @delete="reload"
                        />
                      </template>
                    </TicketList>
                  </v-tab-item>
                  <v-tab-item>
                    <TicketList :id="id" :shared="true" />
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>
        <template v-if="isClient">
          <v-tab-item>
            <div class="custom-scroll-section">
              <CustomerAvailableTimeSlots :timeSlots="model.availableTimeSlots" />
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="custom-scroll-section">
              <IdentityTablesList :profileId="id" />
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="custom-scroll-section">
              <IdentityApplicationsList :profileId="id" />
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="custom-scroll-section">
              <IdentityVIPRecord :profileId="id" />
            </div>
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-container>
    <v-dialog
      v-model="showBooking"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="showBooking = false"
    >
      <v-card color="white" class="pb-1 px-4">
        <booking-detail
          :id="bookingId"
          @close="
            () => {
              showBooking = false;
              bookingId = null;
            }
          "
        >
        </booking-detail>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IdentityDetailsCard from '@/components/Identity/identityDetailsCard';
import IdentityBookingList from '@/components/Identity/IdentityBookingList';
import IdentityHistoricalContracts from '@/components/Identity/IdentityHistoricalContracts.vue';
import IdentityPurchasedProductsList from '@/components/Identity/IdentityPurchasedProductsList.vue';
import CustomerAvailableTimeSlots from '@/components/CustomerAvailableTimeSlots.vue';
import IdentityTablesList from '@/components/Identity/IdentityTablesList.vue';
import IdentityApplicationsList from '@/components/Identity/IdentityApplicationsList.vue';
import IdentityVIPRecord from '@/components/Identity/IdentityVIPRecord.vue';
import { readProfile, getUserListByProfileId, readProfileByMaster } from '@/api/auth/membership';
import api from '@/api';
import RatingRecordList from '@/components/Rating/RatingRecordList';
import BookingDetail from '@/components/Booking/BookingDetail';
import TicketList from '@/components/Ticket/TicketList';
import { RESTFUL, roles } from '@/data/constants';
import ColumnBasedFourCellsLayout from '@/components/detailPageLayout/ColumnBasedFourCellsLayout';
import { mapGetters } from 'vuex';
import { roleOptions } from '@/data/optionsConstants';
import PayrollNoteByIdentity from '@/components/Payroll/PayrollNoteByIdentity';
import PayrollRecords from '@/components/Payroll/PayrollRecords';
import CommissionDetails from '@/components/Commission/CommissionDetails';
import { crudList, crudUpdate } from '@/api/crud';
import moment from 'moment';
import { getOid } from '@/services/utils';
import { listProductCategories } from '@/api/productCategory';
import ProductOrderEditDialog from '@/components/PhysicalProductOrder/ProductOrderEditDialog';

export default {
  props: {
    id: {},
  },
  data() {
    return {
      roles,
      labels: [],
      model: {},
      showBooking: false,
      bookingId: null,
      packageTabs: null,
      profileTabs: null,
      userId: null,

      editProductOrderDialog: false,
      productCategories: [],
    };
  },
  components: {
    // CommissionDetails,
    // ColumnBasedFourCellsLayout,
    // TicketList,
    // BookingDetail,
    // RatingRecordList,
    IdentityDetailsCard,
    CustomerAvailableTimeSlots,
    IdentityTablesList,
    IdentityApplicationsList,
    IdentityVIPRecord,
    // IdentityBookingList,
    // IdentityPurchasedProductsList,
    // IdentityHistoricalContracts,
    // PayrollNoteByIdentity,
    // PayrollRecords,
    // ProductOrderEditDialog,
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  computed: {
    isClient() {
      return this.model?.role === roles.client;
    },
    ...mapGetters('auth', ['role']),
    isMaster() {
      return this.model?.role === roles.master;
    },
    isCashier() {
      return this.model?.role === roles.cashier;
    },
    isAdmin() {
      return this.model?.role === roles.admin;
    },
    roleOptions: () => roleOptions,
  },
  beforeMount() {
    // this.getProductCategories();
  },
  methods: {
    showBookingDetails(id) {
      this.bookingId = id;
      this.showBooking = true;
      // this.$router.push({
      //   name: 'booking',
      //   params: {
      //     id,
      //   },
      // });
    },
    showPhysicalProductOrder(id) {
      this.$router.push({
        name: 'physicalProductOrder',
        params: {
          id,
        },
      });
    },
    async reload() {
      if (this.role !== roles.master) {
        this.model = await readProfile(api, this.id, {
          // TODO: until backend support this populate
          // populates: 'user',
        });
        // TODO: remove this after backend support this populate
        const user = (await getUserListByProfileId(api, getOid(this.id)))?.[0];
        this.model.user = user;
        // this.labels = await autocompleteLabels(api);
        if (this.isMaster || this.isAdmin || this.isCashier) {
          this.userId = getOid(user); //(await getUserListByProfileId(api, this.id)).docs?.[0]?._id;
        }
        // const res = await Promise.all([
        //   this.getEmployeeContract(),
        //   this.getEmployeePayroll(moment()),
        // ]);
        // const data = await Promise.all(res);
        // this.model.contract = data[0];
        // this.model.payroll = data[1];
      } else {
        this.model = await readProfileByMaster(api, this.id);
      }
    },
    async getEmployeeContract() {
      if (!this.model?._id) return;
      try {
        return (
          await crudList(api, 'bn/admin/employeeContracts', {
            filter: { staff: this.model._id, isActivate: true },
            sort: { created_at: -1 },
          })
        ).docs[0];
      } catch (e) {
        console.error(e);
      }
    },
    async getEmployeePayroll(date = null) {
      if (!this.model?._id) return;
      try {
        return (
          await crudList(api, RESTFUL.payrollRecords.list, {
            filter: {
              staff: this.model._id,
              'time.start': { $gte: moment(date).startOf('month') },
              'time.end': { $lte: moment(date).endOf('month') },
            },
            sort: { created_at: -1 },
          })
        ).docs[0];
      } catch (e) {
        console.error(e);
      }
    },
    async getProductCategories() {
      this.productCategories = await listProductCategories(api);
    },
    async updateHistoricalContracts(historicalContracts) {
      await crudUpdate(api, RESTFUL.masterProfile.list, this.model?._id, {
        historicalContracts,
      });
      this.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.fullWidth {
  width: 100%;
}

.font-size-14 {
  font-size: 14px;
}

.placeholder {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.custom-scroll-section {
  overflow-y: auto;
  height: calc(100vh - 108px);
}
</style>
